package org.hs_soft.runmynesto.data.api_datasource.home

import com.varabyte.kobweb.browser.http.AbortController
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.home.global_search.GlobalSearchModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.home.GlobalSearchRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils


class GlobalSearchRepositoryImpl (
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): GlobalSearchRepository {

    private var abortController: AbortController? = null

    override suspend fun getGlobalSearchData(
        searchValue:String
    ):GlobalSearchModel
    {
        abortController = requestManager.createController()


        val isDate = searchValue.matches(Regex("\\d{4}-\\d{2}-\\d{2}"))

        val searchField = if (isDate) "date" else "string"

        val graphQLQuery = buildJsonObject {
            put(
                "query", """
                   query {
                     cashAssist {
                       globalSearch(search: {
                         $searchField: "$searchValue"
                       }) {
                         ...on Product {
                           ${ApiUtils.Field.id}
                           ${ApiUtils.Field.name}
                           ${ApiUtils.Field.code}
                         }
                         ...on User {
                           ${ApiUtils.Field.id}
                           ${ApiUtils.Field.name}
                           ${ApiUtils.Field.code}
                         }
                         ...on Closing {
                           ${ApiUtils.Field.id}
                           ${ApiUtils.Field.number}
                           ${ApiUtils.Field.date}
                         }
                         ${ApiUtils.Field.__typename}
                       }
                     }
                   }
                """.trimIndent()
            )
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController!!,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }
}